import React, { useEffect, useRef } from "react";
import { IoClose } from "react-icons/io5";
import TransactionDetails from "./TransactionDetails";

const TransactionDetailsModal = ({
    isOpen,
    txn,
    typeToIcon,
    onClose,
    containerClassName,
    panelClassName = "",
}) => {
    const panelRef = useRef(null);

    useEffect(() => {
        if (!isOpen || !panelRef.current) return;
        const previous = document.activeElement;
        panelRef.current.focus();
        return () => previous?.focus();
    }, [isOpen]);

    if (!isOpen || !txn) return null;

    const defaultContainer = "lg:hidden";
    const containerClasses = `fixed inset-0 z-[999] ${containerClassName ?? defaultContainer}`;

    return (
        <div className={containerClasses} role="dialog" aria-modal="true">
            <div className="absolute inset-0 bg-black/40" onClick={onClose} />
            <div
                ref={panelRef}
                tabIndex={-1}
                className={`absolute right-0 top-0 h-full w-full sm:w-[420px] bg-white 
                    transform transition-transform duration-300 translate-x-0 ${panelClassName}`}
            >
                <div className="flex items-center justify-between !px-5 pt-4 border-b">
                    <h2 className="!text-lg mb-0 font-semibold text-[#101828]">
                        Transaction details
                    </h2>
                    <button
                        onClick={onClose}
                        className="rounded-full hover:bg-gray-100 focus:outline-none"
                    >
                        <IoClose size={22} className="text-[#475467]" />
                    </button>
                </div>

                <div className="overflow-y-auto h-[calc(100%-4rem)]">
                    <TransactionDetails txn={txn} typeToIcon={typeToIcon} />
                </div>
            </div>
        </div>
    );
};

export default TransactionDetailsModal;
